/**
 * Anexa o bilhete (token) do usuário logado às chamadas de servidor.
 *
 * O token é sempre gerado a partir de public.users no Postgres próprio.
 * Não existe fallback para outro serviço ou schema de autenticação.
 */
import { createMiddleware } from "@tanstack/react-start";
import bancoConfig from "@/../config/banco.config.json";

let ultimoDiagnosticoToken = "";

export const anexarToken = createMiddleware({ type: "function" }).client(async ({ next }) => {
  let token: string | null = null;
  let modo = "none";
  try {
    const { tokenExterno } = await import("@/lib/auth-externo");
    token = tokenExterno();
    if (token) modo = "externo";
    // Se não houver token externo, tenta o Supa-base no cliente apenas quando
    // o modo EXTERNO não estiver ativo. Quando o app usa Postgres externo,
    // o servidor só aceita tokens assinados pelo próprio banco externo.
    const usarExterno =
      String((bancoConfig as any)?.usar ?? "cloud").toLowerCase() === "externo" &&
      String((bancoConfig as any)?.externo?.host ?? "").trim() !== "";
    if (!token && !usarExterno) {
      try {
        const { obterClienteDados } = await import("@/lib/obter-dados");
        const cliente = await obterClienteDados();
        if (cliente?.auth && typeof cliente.auth.getSession === "function") {
          const sess = await cliente.auth.getSession();
          token = (sess as any)?.data?.session?.access_token ?? null;
          if (token) modo = "cloud";
        }
      } catch {
        // falha silenciosa — continua sem token
      }
    }
  } catch {
    // nada
  }

  try {
    const { logAuthCliente } = await import("@/lib/auth-log");
    const diagnostico = {
      modo,
      tokenPresente: !!token,
      tokenTamanho: token?.length ?? 0,
      tokenPrefixo: token?.slice(0, 12) ?? null,
    };
    const assinaturaDiagnostico = JSON.stringify(diagnostico);
    if (assinaturaDiagnostico !== ultimoDiagnosticoToken) {
      ultimoDiagnosticoToken = assinaturaDiagnostico;
      logAuthCliente("Token anexado à chamada server-side", diagnostico);
    }
  } catch {
    /* ignora diagnósticos */
  }

  return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
});
